import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import {  object, string } from "yup";
import { ModuleFormValues } from "src/models/Module.model";
import ModuleForm from "../Layouts/ModuleForm";
import { useAddModuleMutation } from "src/services/ModuleServices";
import { showToast } from "src/utils/showToaster";

type Props = {
  onClose: () => void;
};

const AddModuleFormWrapper = ({ onClose }: Props) => {
  const [saveNextChecked, setSaveNextChecked] = useState(true);

  // Form Initial Values
  const initialValues: ModuleFormValues = {
    moduleName: "",
    chapterId: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    moduleName: string().required("Please enter module name"),
  });

  //API
  const [addModule] = useAddModuleMutation();

  // Handle Submit
  const handleSubmit = (
    values: ModuleFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ModuleFormValues>
  ) => {
    const formattedValues = {
      moduleName: values?.moduleName,
      chapterId: values?.chapterId ? values?.chapterId?.map((chapter: any) => chapter?.value) : [],
    }; 
    addModule(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <ModuleForm
              formType="ADD"
              formikProps={formikProps}
              onClose={onClose}
              setSaveNextChecked={setSaveNextChecked}
              saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddModuleFormWrapper;
